export const createMonthlyReportService = (fetch) => async (monthlyReport) => {
  try {
    const response = fetch({
      url: "/api/v1/informes-mensuales",
      method: "post",
      body: monthlyReport,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
